import React from "react";

export interface SntIconProps {
  size?: number | string;
  color?: string;
  title?: string;
  className?: string;
  onClick?: (event: React.MouseEvent<SVGSVGElement>) => void;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  viewBox?: string;
  role?: string;
  stroke?: string;
}

const SntIcon: React.FC<SntIconProps> = ({
  size = 16,
  color = "currentColor",
  title,
  className = "",
  onClick,
  style,
  children,
  viewBox = "0 0 16 16",
  role,
}) => {
  return (
    <svg
      width={size}
      height={size}
      onClick={onClick}
      className={`snt-owner-icon ${className}`}
      style={style}
      role={role || (onClick ? "button" : undefined)}
      viewBox={viewBox}
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      {title && <title>{title}</title>}
      {children}
    </svg>
  );
};

export default SntIcon;
